<template>
    <article class="execution-step">
        <header class="execution-step__header">
            <SvgIcon class="execution-step__header-icon" 
                :name="iconName" 
                size="big" />
            <span class="execution-step__order-number">{{ orderStepString }}</span>
        </header>
        <h3 class="execution-step__title">{{ title }}</h3>
        <p class="execution-step__description">{{ description }}</p>
    </article>
</template>

<script>
import SvgIcon from './SvgIcon';
export default {
    name: 'ExecutionStep',
    components: {
        SvgIcon
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        iconName: {
            type: String,
            required: true
        },
        orderNumber: {
            type: Number,
            required: true
        }
    },
    computed: {
        orderStepString() {
            return this.orderNumber < 10 ? '0' + this.orderNumber : this.orderNumber;
        }
    }
}
</script>

<style scoped lang="scss">
.execution-step {
    $border-radius-desktop: $border-radius-default;
    $padding-desktop: $gap-medium;

    overflow: hidden;

    height: 100%;
    padding: rem($padding-desktop);

    border-radius: rem($border-radius-desktop);
    background-color: $color-card-background-primary;

    &__header {
        @include flex-space-between;

        &-icon {
            color: $primary;
        }
    }

    &__order-number {
        @include text-xl;

        color: $color-text-muted-high;

        @media #{$screen-big} {
            font-size: rem($font-size-large);
        }
    }

    &__title {
        @include text-medium($font-weight-bold, $line-height-large);

        margin: rem($gap-normal) 0;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }
    }

    &__description {
        @include text-normal;

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }
}
</style>